<div class="contentContainer">
<table mat-table [dataSource]="dataSource" matSort>

  <ng-container matColumnDef="bezeichnung">
    <th mat-header-cell *matHeaderCellDef> {{ 'pages.zeitverwaltung.table.bezeichnung' | translate }} </th>
    <td mat-cell *matCellDef="let spese"> {{spese.spesenArt }} </td>
  </ng-container>

  <ng-container matColumnDef="menge">
    <th mat-header-cell *matHeaderCellDef> {{ 'pages.zeitverwaltung.table.menge' | translate }} </th>
    <td mat-cell class="smallField" *matCellDef="let spese"> {{ spese.menge | number:'1.2':'en-US'}} </td>
  </ng-container>

  <ng-container matColumnDef="betragInt">
    <th mat-header-cell *matHeaderCellDef> {{ 'pages.zeitverwaltung.table.betragInt' | translate }} </th>
    <td mat-cell class="smallField" *matCellDef="let spese"> {{ spese.betragInt | number:'1.2':'en-US' }} </td>
  </ng-container>

  <ng-container matColumnDef="betragExt" >
    <th mat-header-cell *matHeaderCellDef> {{ 'pages.zeitverwaltung.table.betragExt' | translate }} </th>
    <td mat-cell class="smallField" *matCellDef="let spese"> {{spese.betragExt | number:'1.2':'en-US'}} </td>
  </ng-container>

  <ng-container matColumnDef="beschreibung" >
    <th mat-header-cell *matHeaderCellDef> {{ 'pages.zeitverwaltung.table.beschreibung' | translate }} </th>
    <td mat-cell *matCellDef="let spese"> {{spese.beschreibung}} </td>
  </ng-container>

  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef> </th>
    <td  mat-cell *matCellDef="let spese" >
      <button class="action-menu-button" mat-icon-button [matMenuTriggerFor]="actionMenu">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #actionMenu="matMenu">
        <button  mat-menu-item (click)="editSpese(spese)">{{ 'pages.zeitverwaltung.actions.edit' | translate }}</button>
        <button  mat-menu-item (click)="deleteSpese(spese)">{{ 'pages.zeitverwaltung.actions.delete' | translate }}</button>
      </mat-menu>
    </td>
  </ng-container>

  <tr mat-header-row class="header-table-row" *matHeaderRowDef="displayedColumns sticky: true;" ></tr>
  <tr mat-row class="table-row" *matRowDef="let myRowData; columns: displayedColumns" (dblclick)="editSpese(myRowData)"></tr>
</table>
</div>
